module.exports = __webpack_public_path__ + "img/feedback.460a85e8.svg";